import React from 'react'
import { Button, Container, Icon, Header, Visibility, Segment } from 'semantic-ui-react'
import { Link, withRouter } from 'react-router-dom';


import Fade from 'react-reveal/Fade';

// export class DesktopContainer extends Component {
//     render() {
//         return (
//             <div>

//             </div>
//         )
//     }
// }

// export default DesktopContainer


const DesktopContainer = () => (
    <Visibility once={false}
    //   onBottomPassed={this.showFixedMenu}
    //   onBottomPassedReverse={this.hideFixedMenu}
    >
        <Segment textAlign='left' style={{ minHeight: 300, background: '#1B1C1D', 
         borderTop: "5px solid #1B1C1D",
    }} vertical>
        
            <Container text >
                {/* <Header as='h2' content='Machine Learning Studio' inverted style={{ fontSize: '1.7em', fontWeight: 'normal', marginTop: '1.5em', }} /> */}

                {/* <Header as='h1' content='Machine Learning Studio' inverted style={{ fontSize: '4em', fontWeight: 'normal', marginBottom: 0, marginTop: '3em', }} /> */}

                <Fade left cascade>
                    <div style={{ marginTop: '3em', }}>
                        <Header as='h1' content='Machine Learning '   style={{ fontSize: '4.5em', fontWeight: 'normal', marginTop: '1.0em', color:'#FAF0E6' }} />
 

            {/* <Header as='h1' content=' '   style={{ fontSize: '4.5em', fontWeight: 'normal', marginBottom: '.5em', color:'#FAF0E6' }} /> */}
 
                    </div>
                </Fade>

                <Fade right cascade>
                    <div style={{ marginTop: '3em', }}>
 
                        <Header as='h1' content=' Studio'   style={{ fontSize: '4.5em', fontWeight: 'normal', marginBottom: '.5em', color: '#FFFFF0' }} />
                    </div>

              
                </Fade>
{/* 
                <div style={{ background: 'white', minHeight: 50, }}>
                    <Button primary size='huge'  >

    


                        <Link name='Get Started' style={{ marginBottom: '.5em', color: 'white' }} to="/cardlist/card/add" as={Link}>
                            Get Started   <Icon name='right arrow' /></Link>
                    </Button>


                </div> */}


            </Container>
        </Segment>
    </Visibility>

)


export default DesktopContainer;